import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { adminGuard } from './guards/admin.guard';

// Direct imports to avoid chunks
import { LoginComponent } from './components/login/login.component';
import { SignupComponent } from './components/signup/signup.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { ProfileComponent } from './components/profile/profile.component';
import { ManageRelativesComponent } from './components/manage-relatives/manage-relatives.component';
import { ApproveRelativesComponent } from './components/approve-relatives/approve-relatives.component';
import { HierarchyComponent } from './components/hierarchy/hierarchy.component';
import { RelativeDetailsComponent } from './components/relative-details/relative-details.component';
import { RelativeTimelineComponent } from './components/relative-timeline/relative-timeline.component';
import { FamilyTimelineComponent } from './components/family-timeline/family-timeline.component';
import { RelationshipCalculatorComponent } from './components/relationship-calculator/relationship-calculator.component';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy.component';
import { TermsOfServiceComponent } from './components/terms-of-service/terms-of-service.component';
import { ActivityFeedComponent } from './components/activity-feed/activity-feed.component';
import { SettingsComponent } from './components/settings/settings.component';
import { HomeComponent } from './components/home/home.component';
import { InviteRelativeComponent } from './components/invite-relative/invite-relative.component';

export const routes: Routes = [
  // Public routes (no authentication required)
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'signup', component: SignupComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'relationship-calculator', component: RelationshipCalculatorComponent },
  { path: 'privacy-policy', component: PrivacyPolicyComponent },
  { path: 'terms-of-service', component: TermsOfServiceComponent },
  
  // Protected routes (authentication required)
  { 
    path: 'home', 
    component: HomeComponent,
    canActivate: [authGuard]
  },
  { 
    path: 'feed', 
    component: ActivityFeedComponent,
    canActivate: [authGuard]
  },
  { 
    path: 'dashboard', 
    component: DashboardComponent,
    canActivate: [authGuard]
  },
  { 
    path: 'profile', 
    component: ProfileComponent,
    canActivate: [authGuard]
  },
  { 
    path: 'invite-relative', 
    component: InviteRelativeComponent,
    canActivate: [authGuard]
  },
  { 
    path: 'settings', 
    component: SettingsComponent,
    canActivate: [adminGuard]
  },
  
  // Admin routes (admin authentication required)
  { 
    path: 'admin', 
    redirectTo: '/dashboard',
    pathMatch: 'full'
  },
  { 
    path: 'manage-relatives', 
    component: ManageRelativesComponent,
    canActivate: [adminGuard]
  },
  { 
    path: 'approve-relatives', 
    component: ApproveRelativesComponent,
    canActivate: [adminGuard]
  },
  { 
    path: 'hierarchy/:id', 
    component: HierarchyComponent,
    canActivate: [authGuard]
  },
  { 
    path: 'relative/:id', 
    component: RelativeDetailsComponent,
    canActivate: [authGuard]
  },
  { 
    path: 'relative/:id/timeline', 
    component: RelativeTimelineComponent,
    canActivate: [authGuard]
  },
  { 
    path: 'relative/:id/family-timeline', 
    component: FamilyTimelineComponent,
    canActivate: [authGuard]
  },
  
  // Catch-all route - redirect to login
  { path: '**', redirectTo: '/login' }
];
